import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import * as GameTypes from 'types/game.types';
import ColorPhasingElement from './color-phasing-element.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'phasing-background',
  props: {
    targetColor: null,
    steps: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    /**
     * The target color, which is only used to ensure that any step w/ the color set to 'random'
     * will be a color that is sufficiently different from the target color.
     */
    targetColor: chroma.Color,
    /**
     * The color phase steps
     */
    steps: GameTypes.PhaseStep[],
}



const phaseRef = ref();
expose({
    stop: () => phaseRef.value.stop()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ColorPhasingElement, _mergeProps({
    ref_key: "phaseRef",
    ref: phaseRef
  }, _ctx.$attrs, {
    targetColor: props.targetColor,
    steps: props.steps,
    class: "k-phase-bg absolute-full-cover"
  }), null, 16, ["targetColor", "steps"]))
}
}

})